/* eslint-disable no-unused-vars */
enum StatusCode {
  OK = 200,
  FORBIDDEN = 401,
}

export default StatusCode;
